<!-- 注册 -->
<template>
  <div class="register">
    <!-- 导航栏-->
    <van-nav-bar title="注册账号" fixed placeholder z-index="100" @click-left="goBack">
      <template #left>
        <img src="@/assets/img/position/back.png" class="back" />
      </template>
    </van-nav-bar>
    <div class="reg-box">
      <!-- 姓名 -->
      <div class="reg-item">
        <p class="name">姓名</p>
        <input type="text" v-model="name" id="name" placeholder="请输入姓名，如张先生(女生)" />
      </div>
      <!-- 职务 -->
      <div class="reg-item">
        <p class="name">职务</p>
        <input type="text" v-model="duty" placeholder="请填写您的职务" />
      </div>
      <!-- 手机号 -->
      <div class="reg-item">
        <p class="name">手机号</p>
        <input type="text" v-model="telphones" placeholder="请填写您的联系手机号" />
      </div>
      <!-- 图片验证码 -->
      <!-- <div class="reg-item reg-code">
        <div class="left">
          <p class="name">图片验证码</p>
          <input type="text" v-model="regCode" placeholder="输入右侧图片验证码" />
        </div>
        <img src="@/assets/img/enimg/code.png" class="code" />
      </div>-->
      <!-- 短信验证码 -->
      <!-- <div class="reg-item reg-code">
        <div class="reg-bottom">
          <div class="left num-code">
            <p class="name">验证码</p>
            <input type="text" v-model="regNum" placeholder="输入短信验证码" />
          </div>
          <button class="btn-code">获取验证码</button>
        </div>
      </div>-->
      <!-- 账号 -->
      <div class="reg-item">
        <p class="name">设置登录账号</p>
        <input type="text" v-model="accountNumber" placeholder="请设置您的登录账号" :disabled="token==2"/>
        <!-- <p class="name" style="font-size:0.24rem;padding-top:0.15rem">输入6~16个字符，由英文、数字组成，不可使用符号</p> -->
      </div>
      <!-- 密码 -->
      <div class="reg-item">
        <p class="name">设置密码</p>
        <input type="password" v-model="passWord" placeholder="请设置您的登录密码" :disabled="token==2"/>
        <p class="name" style="font-size:0.24rem;padding-top:0.15rem">输入6~18个字符，由英文、数字组成，不可使用符号</p>
      </div>
    </div>
    <!-- 按钮 -->
    <div class="request-btn">
      <button class="btns" @click="registerUser">下一步，填写企业信息</button>
    </div>
    <div class="login-lianxi">
      <a href="tel:85711525">就业创业科联系电话：85711525</a>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { Toast } from "vant";
import { regTelphone } from "@/until/reg";
import { companyGetRegister } from "@/api/apiData";
export default {
  name: "compny",
  components: {},
  data() {
    return {
      name: "", //姓名
      duty: "", //职务
      telphones: "", //联系手机
      regCode: "", //图片验证码
      regNum: "", //短信验证码
      passWord: "", //密码
      accountNumber: "", //登录账号
      info: "" //注册信息
    };
  },
  computed: {
    ...mapState(["password", "telphone", "token"])
  },
  methods: {
    ...mapMutations(["companyRegister"]),
    goBack() {
      this.$router.back();
    },
    // 注册
    registerUser() {
      var that = this;
      let { name, duty, telphones, passWord, accountNumber, info } = that;
      if (name.replace(/[, ]/g, "").length == 0) {
        Toast.fail({
          message: "请填写姓名",
          forbidClick: true
        });
        return;
      }
      if (duty.replace(/[, ]/g, "").length == 0) {
        Toast.fail({
          message: "请填写职务",
          forbidClick: true
        });
        return;
      }
      if (!regTelphone(telphones)) {
        Toast.fail({
          message: "请填写正确的手机号码",
          forbidClick: true
        });
        return;
      }
      if (accountNumber.replace(/[, ]/g, "").length == 0) {
        Toast.fail({
          message: "请填写正确格式的登录账号",
          forbidClick: true
        });
        return;
      }
      if (passWord.replace(/[, ]/g, "").length == 0) {
        Toast.fail({
          message: "请填写正确的格式的登录密码",
          forbidClick: true
        });
        return;
      }
      if (that.token == 2) {
        var params = [name, duty, telphones, accountNumber, passWord,info];
      } else {
        var params = [name, duty, telphones, accountNumber, passWord];
      }
      that.companyRegister(params);
      that.$router.push({
        name: "Information",
        query: {
          type: 1
        }
      });
    },
    // 获取企业注册信息
    getCompanyInfo() {
      const that = this;
      let obj = {
        username: that.telphone,
        password: that.password
      };
      companyGetRegister(obj).then(res => {
        if (res.code == 1) {
          let data = res.data;
          that.name = data.contact; //姓名
          that.duty = data.contact_position; //职位
          that.telphones = data.telphone; //企业手机号
          that.accountNumber = that.telphone; //企业登录账号
          that.passWord = that.password; //企业登录密码
          that.info = data;
        
        }
      });
    }
  },
  created() {},
  mounted() {
    if (this.token == 2) {
      this.getCompanyInfo();
    }
  }
};
</script>
<style lang='less' scoped>
.register {
  padding: 0 0.32rem 0.3rem;
  background: #f7f7f7;
  margin-bottom: 1.3rem;
  .reg-box {
    margin: 0.2rem 0;
    background: #fff;
    border-radius: 0.12rem;
    .reg-item {
      display: flex;
      flex-direction: column;
      padding: 0.3rem 0.32rem;
      .name {
        box-sizing: border-box;
        font-size: 0.28rem;
        font-weight: 400;
        line-height: 0.4rem;
        color: rgba(128, 128, 128, 1);
      }
      input {
        width: 100%;
        font-size: 0.36rem;
        line-height: 0.5rem;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        margin-top: 0.2rem;
        border-bottom: 0.01rem solid #e5e5e5 !important;
        padding-bottom: 0.14rem;
      }
      .left {
        width: 55%;
      }
      input::-webkit-input-placeholder {
        font-size: 0.36rem;
        font-weight: 400;
        line-height: 0.5rem;
        color: rgba(229, 229, 229, 1);
      }
      .code {
        width: 2.48rem;
        height: 1.28rem;
        align-self: flex-end;
      }
      .btn-code {
        background: #e5e5e5;
        border: 0.01rem solid #cccccc;
        opacity: 1;
        border-radius: 0.08rem;
        font-size: 0.2rem;
        padding: 0.22rem 0.3rem;
        align-self: flex-end;
        margin-bottom: 0.2rem;
      }
    }
    .reg-code {
      flex-direction: row;
      justify-content: space-between;
      .reg-bottom {
        border-bottom: 0.01rem solid #e5e5e5;
        width: 100%;
        display: flex;
        justify-content: space-between;
        input {
          border: 0 !important;
          padding-bottom: 0;
        }
      }
    }
  }
  .login-lianxi {
    font-size: 0.3rem;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    margin: 0.5rem 5%;
  }
}
</style>